import { IS_MONUMENTATION_TYPE_SHOW } from './monumentation-type';

export enum LotField {
  BANK = 'bank',
  BLOCK = 'block',
  MONUMENTATION_TYPE = 'monumentationType',
  RIGHTS = 'rights',
  ROW = 'row',
  TIER = 'tier',
}

export const LotFieldLabel = {
  [LotField.BANK]: 'Bank',
  [LotField.BLOCK]: 'Block',
  [LotField.MONUMENTATION_TYPE]: 'Allowed monument',
  [LotField.RIGHTS]: 'Rights',
  [LotField.ROW]: 'Row',
  [LotField.TIER]: 'Tier',
};

export const LOT_DETAILS: LotField[] = [
  LotField.BLOCK,
  LotField.TIER,
  LotField.ROW,
  LotField.BANK,
  LotField.RIGHTS,
  ...(IS_MONUMENTATION_TYPE_SHOW ? [LotField.MONUMENTATION_TYPE] : []),
];

export const DESCRIPTION_LABEL = 'Description';
